import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog, {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import InvestIcon from 'material-ui-icons/AttachMoney';
import CheckCircle from 'material-ui-icons/CheckCircle';
import WarningIcon from 'material-ui-icons/Warning';
import FormControlLabel from 'material-ui/Form/FormControlLabel';
import Checkbox from 'material-ui/Checkbox';
import { offerStatuses, setUserAction } from 'entoro-shared';
import {
  offerReadyToInvestMutation,
  investorKycRequestMutation,
  investorOffersQuery,
  offerQuery,
} from '../../../apollo';
import { withApollo } from 'react-apollo';
import { DASHBOARD_OFFER_LIMIT as limit } from '../../../config';
import ReadyToInvestAction from './ReadyToInvest/ReadyToInvestAction';
import InvestorKycAction from './InvestorKyc/InvestorKycAction';
import PaymentProcessAction from './PaymentProcess/PaymentProcessAction';
import ConfirmationAction from './ConfirmationAction';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AcuantFileUpload from '../../AcuantFileUploader';
import _ from 'underscore';
import { ExternalLink } from './ExternalLink';
import NotifyBanker from '../../OfferOverview/ReadyToInvestButton/NotifyBanker';
import TTWaters from '../../TTWaters';

class ReadyToInvestButton extends Component {
  state = {
    mainDialogOpen: false,
    confirmDialogOpen: false,
    showKycText: false,
    agreeToProvideAccredited: false,
    showInvestmentLimit: [],
    alertShow: false,
    displayDialog: true,
    hasUploadedKycDocx: this.props.investorUser.hasUploadedKycDocx,
    showInvestmentForm: this.props.investorUser.showInvestmentForm,
  };

  componentDidUpdate(prevProps, prevState) {
    const MySwal = withReactContent(Swal);

    if (prevState.alertShow != this.state.alertShow) {
      MySwal.fire({
        title: 'Thank you for your interest',
        text: ' This deal is for Accredited Investors only please review your Accreditation status in your Account Profile.',
        icon: 'warning',
        confirmButtonColor: '#808080',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: `Review`,
        cancelButtonText: `Continue`,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/account/qualification';
        } else if (result.isDismissed) {
          return false;
        }
      });
    }
  }

  alertShowModal = () => {
    const MySwal = withReactContent(Swal);
    return MySwal.fire({
      title: 'Thank you for your interest',
      text: ' This deal is for Accredited Investors only please review your Accreditation status in your Account Profile.',
      icon: 'warning',
      confirmButtonColor: '#808080',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: `Review`,
      cancelButtonText: `Continue`,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = '/account/qualification';
      } else if (result.isDismissed) {
        return false;
      }
    });
  };
  showKycConfirmText = () => {
    this.setState({ showKycText: true });
  };

  toggleConfirmDialog = () => {
    this.setState({
      confirmDialogOpen: !this.state.confirmDialogOpen,
      showInvestmentForm: false,
    });
  };

  handleClickOpen = () => {
    this.setState({ mainDialogOpen: true });
  };

  handleClose = () => {
    const { dispatch, investorUser } = this.props;
    this.setState({
      mainDialogOpen: false,
      showKycText: false,
      showInvestmentForm: false,
    });
    investorUser.showDocxForm &&
      dispatch(setUserAction({ showDocxForm: false }));
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleRedirect = (link) => {
    window.open(link, '_self');
  };

  render() {
    const {
      mainDialogOpen,
      confirmDialogOpen,
      showKycText,
      showInvestmentForm,
      hasUploadedKycDocx,
    } = this.state;
    const MySwal = withReactContent(Swal);
    const { kycStatus, offer, startedAccreditation, investorUser, dispatch } =
      this.props;
    localStorage.setItem('disclaimerText', offer.disclaimerText);
    const offerTypeCheck = (offers) => {
      // get the value of all offer types
      // const typeOfOffersChoices = offerTypes.options
      //   .map(({ value: id }) => [id])
      //   .flat();

      // output -> ['REG_A', 'REG_D', 'REG_CF', 'Reg_D_506b', 'Reg_D_504', 'Reg_D_506c', 'Reg_S', 'Rule_147', 'Rule_147A', 'Rule_144', 'Rule_144A']

      // parse the incoming offers arguments as a string from array
      let offerStrings = JSON.stringify(offers).replace(/[\[\]']+/g, '');

      // check required offer type
      return _.without(offers, offerStrings).find(
        (e) => e === offer.typeOfOffer
      );
    };

    const {
      tenant: { primaryContactEmail, theme },
    } = this.context;
    const canInvestStatus =
      offer.status === 'OPEN' ||
      offer.status === 'PRESALE' ||
      offer.status === 'SELFDIRECTED';

    const canInvest =
      offer.enableInvestment &&
      canInvestStatus &&
      investorUser.selectedOptionTypes === 'YES' &&
      offer.listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
      offer.listingType !== 'ASSET_SALES';

    const canInvestRegA =
      offer.enableInvestment &&
      canInvestStatus &&
      offer.listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
      offer.listingType !== 'ASSET_SALES';

    const investorIsAccredited =
      investorUser.accreditationStatus === 'APPROVED' ||
      investorUser.accreditationStatus === 'EXEMPTED';

    const confirmText =
      offer.listingType === 'ASSET_SALES'
        ? 'Thank you for your interest in making an offer, we have emailed the bankers, and you will be contacted shortly by a representative to complete your transaction.'
        : 'Thank you for your interest in investing in this offer, you will be contacted shortly by a representative to complete your transaction.';

    if (
      offerTypeCheck(['REG_A', 'REG_CF', 'REG_D', 'Reg_D_506b', 'Reg_D_506c'])
    ) {
      if (
        offer.locationsToExclude &&
        offer.locationsToExclude.includes(investorUser.country)
      ) {
        return MySwal.fire({
          title: 'Thank you for your interest',
          text: ' This deal is not available for Investors in your country.',
          icon: 'warning',
          confirmButtonColor: '#808080',
          cancelButtonColor: '#d33',
          showCancelButton: true,
          confirmButtonText: `See Disclaimer`,
          cancelButtonText: `Back to Dashboard`,
        }).then((result) => {
          if (result.isConfirmed) {
            return (window.location.href = '/offer-disclaimer');
          } else if (result.isDismissed) {
            // return false;
            window.location.href = '/dashboard/all-offers';
          }
        });
      }
    }

    if (
      offerTypeCheck([
        'Reg_S',
        'Rule_147',
        'Rule_147A',
        'Rule_144',
        'Rule_144A',
        'Carbon_Credit',
        'Asset_Sale',
        'Water',
      ])
    ) {
      // <NotifyBanker
      //   offerId={offer._id}
      //   mutation={offerReadyToInvestMutation}
      // />

      if (
        (kycStatus === 'NOT_STARTED' || kycStatus === 'REJECTED') &&
        !investorUser.showDocxForm
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }

      if (confirmDialogOpen && !canInvest) {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                {offer.status === 'PREMARKETING' ||
                offer.listingType === 'ACQUISITIONS_AND_DIVESTITURES'
                  ? 'Thank you for your interest in investing in this offer, we are not currently accepting investments for this offer. We will notify you when this offer starts accepting investments.'
                  : confirmText}
                <br />
                <br />
                If you have any questions please contact us at
                <a href={`mailto:${primaryContactEmail}`}>
                  {' '}
                  {primaryContactEmail}
                </a>
              </span>
            }
          />
        );
      }

      if (confirmDialogOpen) {
        return (
          <PaymentProcessAction
            open={confirmDialogOpen}
            investorUser={investorUser}
            handleClose={this.toggleConfirmDialog}
            title='Start Investment'
            offer={offer}
          />
        );
      }

      if (
        (kycStatus === 'ACCEPTED' || kycStatus === 'UNDER_REVIEW') &&
        !investorUser.hasUploadedKycDocx
      ) {
        return (
          <ReadyToInvestAction
            open={mainDialogOpen || investorUser.showDocxForm}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offerId={offer._id}
            Icon={InvestIcon}
            title='Investor KYC Verification'
            acuantKyc={true}
            showPreviews={true}
            dialogBody={
              <AcuantFileUpload
                handleClose={this.handleClose}
                handleClickOpen={this.handleClickOpen}
              />
            }
            disabled={
              !startedAccreditation && !this.state.agreeToProvideAccredited
            }
          />
        );
      }

      return (
        <ReadyToInvestAction
          open={mainDialogOpen || showInvestmentForm}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          toggleConfirmDialog={this.toggleConfirmDialog}
          offerId={offer._id}
          mutation={offerReadyToInvestMutation}
          refetchQueries={[
            {
              query: investorOffersQuery,
              variables: {
                query: {
                  limit,
                  skip: 0,
                  sort: 'order',
                  order: 'ASC',
                  filter: {
                    $or: [
                      {
                        favorited: true,
                      },
                      {
                        requestedInformation: true,
                      },
                      {
                        readyToInvest: true,
                      },
                    ],
                  },
                },
              },
            },
            {
              query: offerQuery,
              variables: {
                _id: offer._id,
              },
            },
          ]}
          Icon={InvestIcon}
          title={
            offer.listingType === 'ASSET_SALES'
              ? 'Make Offer'
              : 'Start Investment'
          }
          dialogBody={
            <span>
              {showKycText ? (
                <span>
                  <i>Your KYC Verification Request has been accepted.</i>
                  <br />
                  <br />
                </span>
              ) : null}
              <span>Start the investment process for this offer.</span>
              <br />
              <br />
              <b>Account Review:</b>
              <br />
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Basic Information
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Qualification
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Suitability
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;KYC Verification Complete
              </span>
              {startedAccreditation ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : offerTypeCheck(['REG_A']) ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : (
                <span className='action-dialog-account-info incomplete'>
                  <WarningIcon />
                  &nbsp;Investor Accreditation
                </span>
              )}
              {!startedAccreditation ? (
                <span>
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agreeToProvideAccredited}
                        onChange={this.handleChange('agreeToProvideAccredited')}
                        value='agreeToProvideAccredited'
                      />
                    }
                    label='By continuing you agree to provide information as requested to confirm your accredited status.'
                  />
                </span>
              ) : null}
            </span>
          }
          disabled={
            !startedAccreditation && !this.state.agreeToProvideAccredited
          }
        />
      );
    }

    if (
      offerTypeCheck(['REG_D', 'Reg_D_506b', 'Reg_D_504', 'Reg_D_506c']) ||
      !offer.typeOfOffer
    ) {
      if (offer.externalUrlSwitch) {
        return <ExternalLink offer={offer} />;
      }

      if (confirmDialogOpen && kycStatus === 'UNDER_REVIEW') {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                Your KYC is still being processed. Please check back later or
                contact your admin.
                <br />
                <br />
                <a href={`mailto:${primaryContactEmail}`}>
                  {' '}
                  {primaryContactEmail}
                </a>
              </span>
            }
          />
        );
      }

      if (confirmDialogOpen && !investorIsAccredited) {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                Formal accreditation verification is required for this type of
                offering. Please visit the link below to complete this
                verification prior to being able to complete the investment
                process.
                <br />
                <br />
                Please visit{'   '}
                <a
                  href='https://entoro.investready.com/'
                  target='_blank'
                  style={{
                    backgroundColor: theme.primaryColor,
                    padding: '0 10px',
                    color: 'white',
                    boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.1)',
                    borderRadius: '2px',
                  }}
                >
                  {'   '}
                  Invest Ready
                </a>
                {'   '}
                to get accreditted
              </span>
            }
          />
        );
      }

      if (confirmDialogOpen && !canInvest) {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                {offer.status === 'PREMARKETING' ||
                offer.listingType === 'ACQUISITIONS_AND_DIVESTITURES'
                  ? 'Thank you for your interest in investing in this offer, we are not currently accepting investments for this offer. We will notify you when this offer starts accepting investments.'
                  : confirmText}
                <br />
                <br />
                If you have any questions please contact us at
                <a href={`mailto:${primaryContactEmail}`}>
                  {' '}
                  {primaryContactEmail}
                </a>
              </span>
            }
          />
        );
      }

      if (
        (kycStatus === 'NOT_STARTED' || kycStatus === 'REJECTED') &&
        !investorUser.showDocxForm
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            accreditted={investorUser.selectedOptionTypes !== 'YES'}
            offer={offer}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }

      if (
        (kycStatus === 'ACCEPTED' || kycStatus === 'UNDER_REVIEW') &&
        !investorUser.hasUploadedKycDocx
      ) {
        return (
          <ReadyToInvestAction
            open={mainDialogOpen || investorUser.showDocxForm}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offerId={offer._id}
            Icon={InvestIcon}
            title='Investor KYC Verification'
            acuantKyc={true}
            showPreviews={true}
            dialogBody={
              <AcuantFileUpload
                handleClose={this.handleClose}
                handleClickOpen={this.handleClickOpen}
              />
            }
            disabled={
              !startedAccreditation && !this.state.agreeToProvideAccredited
            }
          />
        );
      }

      if (confirmDialogOpen && canInvest) {
        return (
          <PaymentProcessAction
            open={confirmDialogOpen}
            investorUser={investorUser}
            handleClose={this.toggleConfirmDialog}
            title='Start Investment'
            offer={offer}
          />
        );
      }

      return (
        <ReadyToInvestAction
          open={mainDialogOpen || showInvestmentForm}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          toggleConfirmDialog={this.toggleConfirmDialog}
          offerId={offer._id}
          mutation={offerReadyToInvestMutation}
          refetchQueries={[
            {
              query: investorOffersQuery,
              variables: {
                query: {
                  limit,
                  skip: 0,
                  sort: 'order',
                  order: 'ASC',
                  filter: {
                    $or: [
                      {
                        favorited: true,
                      },
                      {
                        requestedInformation: true,
                      },
                      {
                        readyToInvest: true,
                      },
                    ],
                  },
                },
              },
            },
            {
              query: offerQuery,
              variables: {
                _id: offer._id,
              },
            },
          ]}
          Icon={InvestIcon}
          title={
            offer.listingType === 'ASSET_SALES'
              ? 'Make Offer'
              : 'Start Investment'
          }
          dialogBody={
            <span>
              {showKycText ? (
                <span>
                  <i>Your KYC Verification Request has been accepted.</i>
                  <br />
                  <br />
                </span>
              ) : null}
              <span>Start the investment process for this offer.</span>
              <br />
              <br />
              <b>Account Review:</b>
              <br />
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Basic Information
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Qualification
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Suitability
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;KYC Verification Complete
              </span>
              {startedAccreditation ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : offerTypeCheck(['REG_A']) ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : (
                <span className='action-dialog-account-info incomplete'>
                  <WarningIcon />
                  &nbsp;Investor Accreditation
                </span>
              )}
              {!startedAccreditation ? (
                <span>
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agreeToProvideAccredited}
                        onChange={this.handleChange('agreeToProvideAccredited')}
                        value='agreeToProvideAccredited'
                      />
                    }
                    label='By continuing you agree to provide information as requested to confirm your accredited status.'
                  />
                </span>
              ) : null}
            </span>
          }
          disabled={
            !startedAccreditation && !this.state.agreeToProvideAccredited
          }
        />
      );
    } else if (offer.typeOfOffer === 'REG_A') {
      if (offer.externalUrlSwitch) {
        return <ExternalLink offer={offer} />;
      }

      if (confirmDialogOpen && !canInvestRegA) {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                {offer.status === 'PREMARKETING' ||
                offer.listingType === 'ACQUISITIONS_AND_DIVESTITURES'
                  ? 'Thank you for your interest in investing in this offer, we are not currently accepting investments for this offer. We will notify you when this offer starts accepting investments.'
                  : confirmText}
                <br />
                <br />
                If you have any questions please contact us at
                <a href={`mailto:${primaryContactEmail}`}>
                  {' '}
                  {primaryContactEmail}
                </a>
              </span>
            }
          />
        );
      }

      if (offer.testWatersToggle) {
        return (
          <TTWaters
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
          />
        );
      }
      if (
        offer.processType === 'KORECONX' ||
        offer.processType === 'FUNDAMERICA'
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }
      if (
        (kycStatus === 'NOT_STARTED' || kycStatus === 'REJECTED') &&
        !investorUser.showDocxForm
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }

      if (confirmDialogOpen && canInvestRegA) {
        return (
          <PaymentProcessAction
            open={confirmDialogOpen}
            investorUser={investorUser}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.toggleConfirmDialog}
            title='Start Investment'
            offer={offer}
          />
        );
      }
      if (
        (kycStatus === 'ACCEPTED' || kycStatus === 'UNDER_REVIEW') &&
        !investorUser.hasUploadedKycDocx
      ) {
        return (
          <ReadyToInvestAction
            open={mainDialogOpen || investorUser.showDocxForm}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offerId={offer._id}
            Icon={InvestIcon}
            title='Investor KYC Verification'
            acuantKyc={true}
            showPreviews={true}
            dialogBody={
              <AcuantFileUpload
                handleClose={this.handleClose}
                handleClickOpen={this.handleClickOpen}
              />
            }
            disabled={
              !startedAccreditation && !this.state.agreeToProvideAccredited
            }
          />
        );
      }
      return (
        <ReadyToInvestAction
          open={mainDialogOpen || showInvestmentForm}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          toggleConfirmDialog={this.toggleConfirmDialog}
          offerId={offer._id}
          mutation={offerReadyToInvestMutation}
          refetchQueries={[
            {
              query: investorOffersQuery,
              variables: {
                query: {
                  limit,
                  skip: 0,
                  sort: 'order',
                  order: 'ASC',
                  filter: {
                    $or: [
                      {
                        favorited: true,
                      },
                      {
                        requestedInformation: true,
                      },
                      {
                        readyToInvest: true,
                      },
                    ],
                  },
                },
              },
            },
            {
              query: offerQuery,
              variables: {
                _id: offer._id,
              },
            },
          ]}
          Icon={InvestIcon}
          title={
            offer.listingType === 'ASSET_SALES'
              ? 'Make Offer'
              : 'Start Investment'
          }
          dialogBody={
            <span>
              {showKycText ? (
                <span>
                  <i>Your KYC Verification Request has been accepted.</i>
                  <br />
                  <br />
                </span>
              ) : null}
              <span>Start the investment process for this offer.</span>
              <br />
              <br />
              <b>Account Review:</b>
              <br />
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Basic Information
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Qualification
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Suitability
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;KYC Verification Complete
              </span>
              {startedAccreditation ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : offerTypeCheck(['REG_A']) ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : (
                <span className='action-dialog-account-info incomplete'>
                  <WarningIcon />
                  &nbsp;Investor Accreditation
                </span>
              )}
              {!startedAccreditation ? (
                <span>
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agreeToProvideAccredited}
                        onChange={this.handleChange('agreeToProvideAccredited')}
                        value='agreeToProvideAccredited'
                      />
                    }
                    label='By continuing you agree to provide information as requested to confirm your accredited status.'
                  />
                </span>
              ) : null}
            </span>
          }
          disabled={
            !startedAccreditation && !this.state.agreeToProvideAccredited
          }
        />
      );
    } else if (offer.typeOfOffer === 'REG_CF') {
      if (offer.externalUrlSwitch) {
        return <ExternalLink offer={offer} />;
      }

      if (confirmDialogOpen && !canInvestRegA) {
        return (
          <ConfirmationAction
            open={confirmDialogOpen}
            toggleConfirmDialog={this.toggleConfirmDialog}
            buttonTitle={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            dialogBody={
              <span>
                {!canInvestStatus && (
                  <Fragment>
                    {`Offer Status: ${offerStatuses.getLabel(offer.status)}`}
                    <br />
                    <br />
                  </Fragment>
                )}
                {offer.status === 'PREMARKETING' ||
                offer.listingType === 'ACQUISITIONS_AND_DIVESTITURES'
                  ? 'Thank you for your interest in investing in this offer, we are not currently accepting investments for this offer. We will notify you when this offer starts accepting investments.'
                  : confirmText}
                <br />
                <br />
                If you have any questions please contact us at
                <a href={`mailto:${primaryContactEmail}`}>
                  {' '}
                  {primaryContactEmail}
                </a>
              </span>
            }
          />
        );
      }

      if (offer.testWatersToggle) {
        return (
          <TTWaters
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
          />
        );
      }
      if (
        offer.republicProcessType ||
        offer.wefunderProcessType ||
        offer.realexProcessType
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }

      if (
        (kycStatus === 'NOT_STARTED' || kycStatus === 'REJECTED') &&
        !investorUser.showDocxForm
      ) {
        return (
          <InvestorKycAction
            open={mainDialogOpen}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            showKycConfirmText={this.showKycConfirmText}
            mutation={investorKycRequestMutation}
            offer={offer}
            title={
              offer.listingType === 'ASSET_SALES'
                ? 'Make Offer'
                : 'Start Investment'
            }
            offerId={offer._id}
          />
        );
      }

      if (confirmDialogOpen && canInvestRegA) {
        return (
          <PaymentProcessAction
            open={confirmDialogOpen}
            investorUser={investorUser}
            handleClose={this.toggleConfirmDialog}
            title='Start Investment'
            offer={offer}
          />
        );
      }
      if (
        (kycStatus === 'ACCEPTED' || kycStatus === 'UNDER_REVIEW') &&
        !investorUser.hasUploadedKycDocx
      ) {
        return (
          <ReadyToInvestAction
            open={mainDialogOpen || investorUser.showDocxForm}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            offerId={offer._id}
            Icon={InvestIcon}
            title='Investor KYC Verification'
            acuantKyc={true}
            showPreviews={true}
            dialogBody={
              <AcuantFileUpload
                handleClose={this.handleClose}
                handleClickOpen={this.handleClickOpen}
              />
            }
            disabled={
              !startedAccreditation && !this.state.agreeToProvideAccredited
            }
          />
        );
      }
      return (
        <ReadyToInvestAction
          open={mainDialogOpen || showInvestmentForm}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          toggleConfirmDialog={this.toggleConfirmDialog}
          offerId={offer._id}
          mutation={offerReadyToInvestMutation}
          refetchQueries={[
            {
              query: investorOffersQuery,
              variables: {
                query: {
                  limit,
                  skip: 0,
                  sort: 'order',
                  order: 'ASC',
                  filter: {
                    $or: [
                      {
                        favorited: true,
                      },
                      {
                        requestedInformation: true,
                      },
                      {
                        readyToInvest: true,
                      },
                    ],
                  },
                },
              },
            },
            {
              query: offerQuery,
              variables: {
                _id: offer._id,
              },
            },
          ]}
          Icon={InvestIcon}
          title={
            offer.listingType === 'ASSET_SALES'
              ? 'Make Offer'
              : 'Start Investment'
          }
          dialogBody={
            <span>
              {showKycText ? (
                <span>
                  <i>Your KYC Verification Request has been accepted.</i>
                  <br />
                  <br />
                </span>
              ) : null}
              <span>Start the investment process for this offer.</span>
              <br />
              <br />
              <b>Account Review:</b>
              <br />
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Basic Information
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Qualification
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;Investor Suitability
              </span>
              <span className='action-dialog-account-info complete'>
                <CheckCircle />
                &nbsp;KYC Verification Complete
              </span>
              {startedAccreditation ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : offerTypeCheck(['REG_A']) ? (
                <span className='action-dialog-account-info complete'>
                  <CheckCircle />
                  &nbsp;Investor Accreditation
                </span>
              ) : (
                <span className='action-dialog-account-info incomplete'>
                  <WarningIcon />
                  &nbsp;Investor Accreditation
                </span>
              )}
              {!startedAccreditation ? (
                <span>
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agreeToProvideAccredited}
                        onChange={this.handleChange('agreeToProvideAccredited')}
                        value='agreeToProvideAccredited'
                      />
                    }
                    label='By continuing you agree to provide information as requested to confirm your accredited status.'
                  />
                </span>
              ) : null}
            </span>
          }
          disabled={
            !startedAccreditation && !this.state.agreeToProvideAccredited
          }
        />
      );
    }
  }
}

const mapStateToProps = (state) => ({
  kycStatus: state.investorUser.kycStatus,
  investorUser: state.investorUser,
});

ReadyToInvestButton.propTypes = {
  offer: PropTypes.object.isRequired,
  startedAccreditation: PropTypes.bool.isRequired,
  kycStatus: PropTypes.string.isRequired,
  investorUser: PropTypes.object.isRequired,
};

ReadyToInvestButton.contextTypes = {
  tenant: PropTypes.object,
};
export default connect(mapStateToProps)(withApollo(ReadyToInvestButton));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/index.js